import axios from "axios";
import tokenManager from "../../utils/tokenManager";
import { handleApiError } from "../../utils/apiErrorHandler";
import logger from "../../utils/logger";

const serviceRegistry = {
  auth: {
      baseURL: process.env.NODE_ENV === 'production' ? "" : (process.env.REACT_APP_AUTH_SERVICE_URL || "http://localhost:5002"),
      endpoints: [
          "/api/auth", 
          "/api/user", 
          "/api/users", 
          "/api/user/send-reset-sms",
          "/api/user/verify-reset-sms",
          "/api/user/refresh-token",
          "/api/auth/reset-password",
          "/api/user/update-password",
          "/api/user/login-history",
          "/api/user/upload-avatar",
          "/api/user/update",
          "/api/users/login", 
          "/api/users/verify-login-mfa", 
          "/api/mfa",
          "/api/register", 
          "/api/check-token",
          "/api/check-phone-availability",
          
      ]
  },
  meeting: {
   baseURL: process.env.NODE_ENV === 'production' ? "" : (process.env.REACT_APP_PAYMENT_SERVICE_URL || "http://localhost:5006"),
   endpoints: [
       "/api/meetings",
       "/api/meetings/analytics",
       "/api/meetings/recent",
       "/api/meetings/create",
   ]
},
  email: {
      baseURL: process.env.NODE_ENV === 'production' ? "" : (process.env.REACT_APP_EMAIL_SERVICE_URL || "http://localhost:5003"),
      endpoints: [
          "/api/email",
          "/api/emails",
          "/api/emails/search",
          "/api/emails/inbox",
          "/api/emails/sent",
          "/api/drafts",
          "/api/emails/delete",
          "/api/emails/junk",
          "/api/emails/archived",
          "/api/emails/thread",
          "/api/inbox",
          "/api/sent",
          "/api/signatures",
          "/api/contacts",
          "/api/folders",
          "/api/events",
          "/api/labels",
          "/api/projects",
          "/api/tasks",
          "/api/calendar",
          "/api/calendar/integrations",
          "/api/calendar/auth/google",
          "/api/calendar/auth/outlook",
          "/api/calendar/auth/apple",
          "/api/calendar/events/integrated",
          "/api/calendar/settings",
          "/api/notes",
          "/api/analytics",
          "/api/send-email",
          "/api/emails/attachments/upload",
          "/api/signatures",
          "api/threads/history",
          "/api/shared/mailbox",
          "/api/bookings",
          "/api/bookings/services",
          "/api/bookings/availability",
          "/api/bookings/available-slots",
          "/api/bookings/recent",
          "/api/bookings/stats",
          "/api/admin/workflows"
      ]
  },
  ai: {
      baseURL: process.env.NODE_ENV === 'production' ? "" : (process.env.REACT_APP_FILE_SERVICE_URL || "http://localhost:5001"),
      endpoints: [
          "/api/ai/chat",
          "/api/ai/support",
          "/api/ai/generate-response",
          "/api/ai/analyze-ticket",
          "/api/ai/suggest-solution"
      ]
  },
  business: {
      baseURL: process.env.NODE_ENV === 'production' ? "" : (process.env.REACT_APP_BUSINESS_SERVICE_URL || "http://localhost:5004"),
      endpoints: [
          "/api/ai/config",
          "/api/ai/rules",
          "/api/ai/agents",
          "/api/ai/integrations",
          "/api/ai/knowledge",
          "/api/ai/analytics",
          "/api/ai/audit",
          "/api/ai/stats",
          "/api/ai/health",
          "/api/ai/workflows",
          "/api/ai/test",
          "/api/ai/initialize",
          "/api/ai",
          "/api/oauth2",
          "/api/oauth2/authorize",
          "/api/oauth2/callback",
          "/api/business",
          "/api/business/update-plan",
          "/api/business/billing",
          "/api/business/status",
          "/api/business/workspace-trial",
          "/api/business/users",
          "/api/billing",
          "/api/billing/upgrade",
          "/api/billing/trial-status",
          "/api/billing/payment-method",
          "/api/billing/history",
          "/api/billing/invoices",
          "/api/business/stripe",
          "/api/business/stripe/setup-intent",
          "/api/business/stripe/confirm-setup",
          "/api/business/stripe/payment-method-details",
          "/api/business/stripe/customers",
          "/api/business/stripe/invoices",
          "/api/business/mailbox",
          "/api/business/domains",
          "/api/business/domains/validate",
          "/api/business/domains/mailbox-permissions",
          "/api/business/users/calendar-permissions",
          "/api/business/users/forwarding-permissions",
          "/api/business/users/email-forwarding",
          "/api/business/users/check-username",         
          "/api/business/dashboard",
          "/api/business/storage",
          "/api/business/storage/analytics",
          "/api/business/reports",
          "/api/business/reports/export",
          "/api/business/support/tickets",
          "/api/business/support/tickets/create",
          "/api/business/support/tickets/update",
          "/api/business/support/chat",
          "/api/business/support/chat/history",
          "/api/business/support/faq",
          "/api/business/support/knowledge-base",
          "/api/business/settings",
          "/api/business/settings/general",
          "/api/business/settings/email",
          "/api/business/settings/security",
          "/api/business/settings/notifications",
          "/api/business/settings/system",
          "/api/business/settings/test-email",
          "/api/business/settings/update",
          "/api/business/settings/api-keys/generate",
          "/api/business/settings/api-keys",
          "/api/business/roles",
          "/api/business/roles/test",
          "/api/business/roles/initialize",
          "/api/business/roles/permissions/list",
          "/api/business/roles/assign",
          "/api/business/erp-modules",
          "/api/business/erp-users/assign",
          "/api/business/erp-users/remove",
          "/api/business/erp-users/assignments",
          "/api/business/erp-users/fix-data",
          "/api/licenses",
          "/api/licenses/platform",
          "/api/licenses/enterprise",
          "/api/licenses/enterprise/upgrade",
          "/api/licenses/overview",
          "/api/licenses/erp-modules",
          "/api/licenses/erp-users",
          "/api/licenses/purchase-module",
          "/api/licenses/assign-erp-user",
          "/api/licenses/erp-user",
          "/api/licenses/ai-agents",
          "/api/licenses/billing-summary",
          "/api/erp/instances",
          "/api/ai-customizer",
          "/api/invoices",
          "/api/invoices/setup-intent",
          "/api/invoices/save-payment-method",
          "/api/invoices/payment-methods",
          "/api/marketing",
          "/api/marketing/campaigns",
          "/api/marketing/templates",
          "/api/marketing/recipient-lists",
          "/api/marketing/stats",
          "/api/twilio",
          "/api/twilio/setup",
          "/api/twilio/config",
          "/api/twilio/test-connection",
          "/api/twilio/numbers",
          "/api/twilio/numbers/sync",
          "/api/twilio/numbers/search",
          "/api/twilio/numbers/purchase",
          "/api/voice",
          "/api/voice/initiate-call",
          "/api/voice/sync-elevenlabs-numbers",
          "/api/voice/calls",
          "/api/voice/stats",
          "/api/job-boards",
          "/api/job-boards/credentials",
          "/api/job-boards/usage",
          "/api/recruitment",
          "/api/recruitment/hiring-requests",
          "/api/recruitment/job-postings",
          "/api/recruitment/candidates",
          "/api/recruitment/stats",
          "/api/recruitment/webhooks",
          "/api/wordpress",
          "/api/wordpress/sites",
          "/api/sip",
          "/api/sip/settings",
          "/api/sip/telnyx",
          "/api/sip/telnyx/status",
          "/api/sip/trunks",
          "/api/sip/did-numbers",
          "/api/sip/extensions",
          "/api/dids",
          "/api/iris",
          "/api/context-analytics"
      ]
  },
  storage: {
      baseURL: process.env.NODE_ENV === 'production' ? "" : "http://localhost:5001",
      endpoints: [
          
          "/api/delete-attachment"
      ]
  },
  default: {
      baseURL: process.env.NODE_ENV === 'production' ? "" : "http://localhost:5004"
  }
};

const publicEndpoints = [
 "/api/users/login",
 "/api/register",
 "/api/user/send-reset-sms",
 "/api/user/verify-reset-sms",
 "/api/auth/reset-password",
 "/api/check-token",
 "/api/check-phone-availability",
 "/api/business/domains/validate",
 "/api/bookings/services/public",
 "/api/bookings/availability/public/slots",
 "/api/bookings/availability/public/settings",
 "/api/bookings/public"
];

const serviceCache = new Map();

const getServiceForEndpoint = (url) => {
  if (serviceCache.has(url)) {
      return serviceCache.get(url);
  }
 
  // Special handling for business domain validation on accounts subdomain
  if (url.includes('/api/business/domains/validate') && window.location.hostname === 'accounts.aiinak.com') {
    const businessService = {
      baseURL: process.env.NODE_ENV === 'production' ? "" : "http://localhost:5004"
    };
    serviceCache.set(url, businessService);
    return businessService;
  }
 
  for (const service of Object.values(serviceRegistry)) {
      if (service.endpoints) {
          for (const endpoint of service.endpoints) {
              if (url.startsWith(endpoint)) {
                  serviceCache.set(url, service);
                  return service;
              }
          }
      }
  }
  
  serviceCache.set(url, serviceRegistry.default);
  return serviceRegistry.default;
};

const axiosInstance = axios.create({
  withCredentials: true,
  timeout: 30000,
  headers: {
      "Content-Type": "application/json",
  },
});

const isPublicEndpoint = (url) => {
 const isPublic = publicEndpoints.some(endpoint => url.includes(endpoint));
 logger.log('🔍 Checking if public endpoint:', url, '→', isPublic);
 return isPublic;
};

const isPublicRoute = () => {
 const path = window.location.pathname;
 return path === '/' || 
        path.includes('/login') || 
        path.includes('/register') || 
        path.includes('/reset-password') ||
        path.includes('/book/');
};

axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.token) {
      tokenManager.setToken(response.data.token);
    }
    return response;
  },
  (error) => {
    // Centralized error handling — shows toast notifications for API errors
    handleApiError(error);

    if (error.response?.status === 401) {
      // Check for redirect loop prevention
      const redirectCount = parseInt(sessionStorage.getItem('redirectCount') || '0');
      const lastRedirectTime = parseInt(sessionStorage.getItem('lastRedirectTime') || '0');
      const now = Date.now();

      // If we've redirected 2+ times in the last 10 seconds, stop redirecting
      if (redirectCount >= 2 && (now - lastRedirectTime) < 10000) {
        if (process.env.NODE_ENV !== 'production') {
          logger.warn('Redirect loop detected, stopping automatic redirects');
        }
        sessionStorage.removeItem('redirectCount');
        sessionStorage.removeItem('lastRedirectTime');
        return Promise.reject(error);
      }

      // Only remove token and redirect if this isn't a booking calendar API call
      const isBookingCalendarCall = error.config?.url?.includes('/api/bookings') &&
                                   window.location.pathname.includes('bookings');

      if (!isBookingCalendarCall) {
        // DON'T remove token on localhost - cookies can't be shared between ports
        const isLocalhost = window.location.hostname.includes('localhost');
        if (!isLocalhost) {
          tokenManager.removeToken("userToken");
        }

        if (!window.location.pathname.includes('/login') && window.location.pathname !== '/') {
          const currentUrl = window.location.href;
          const currentHostname = window.location.hostname;

          // Update redirect counter
          sessionStorage.setItem('redirectCount', (redirectCount + 1).toString());
          sessionStorage.setItem('lastRedirectTime', now.toString());

          let loginUrl;
          if (isLocalhost) {
            loginUrl = `http://localhost:3014/login?redirect=${encodeURIComponent(currentUrl)}`;
          } else {
            const source = currentHostname.split('.')[0];
            loginUrl = `https://accounts.aiinak.com/login?redirect=${encodeURIComponent(currentUrl)}&source=${source}`;
          }

          if (process.env.NODE_ENV !== 'production') {
            logger.log('Redirecting to login (attempt ' + (redirectCount + 1) + '/2)');
          }
          window.location.href = loginUrl;
        }
      }
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  (config) => {
    // Try to get token with explicit logging
    const token = tokenManager.getToken();
    const isPublic = isPublicEndpoint(config.url);
    const isPublicRouteResult = isPublicRoute();

    // Only log when there's an issue
    if (!token && !isPublic && !isPublicRouteResult) {
      logger.warn('No token found for authenticated request:', {
        url: config.url,
        hostname: window.location.hostname,
        hasUserTokenCookie: document.cookie.includes('userToken')
      });
    }
    
    if (!token && !isPublic && !isPublicRouteResult) {
      // Cancel the request pre-flight so we never send an unauthenticated
      // request. AbortController replaces the deprecated axios.CancelToken.
      const controller = new AbortController();
      config.signal = controller.signal;
      controller.abort();

      if (process.env.NODE_ENV !== 'production') {
        logger.warn(`Request to ${config.url} was canceled because it requires authentication`);
      }

      return config;
    }
    
    if (token && !isPublic) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    const hostname = window.location.hostname;
    if (hostname === 'admin.aiinak.com') {
      config.headers['X-Admin-Domain'] = 'true';
    } else if (hostname === 'accounts.aiinak.com') {
      config.headers['X-Accounts-Domain'] = 'true';
    } else if (hostname === 'mail.aiinak.com') {
      config.headers['X-Mail-Domain'] = 'true';
    }
    
    if (!config.headers['Content-Type'] && !config.headers['content-type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    const service = getServiceForEndpoint(config.url);
    config.baseURL = service.baseURL;
    
    if (process.env.NODE_ENV !== 'production') {
      logger.log(`Routing request to ${config.baseURL}${config.url}`);
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;